import { resources } from "@constants/hardcoded-strings";
import {
    ORGANIZATION_INVITATION_DETAILS_URL,
} from "@constants/routes";
import { ORGANIZATION_INVITATION_ID_PATTERN } from "@constants/url-parameter-patterns";
import { CellDropdownItem } from "@idw-types/common";
import { navigateToUtil } from "@utils/navigation-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TableCellWithDropdown } from "@containers/common/table-cell-with-dropdown/table-cell-with-dropdown";
import { OrganizationInvitationsTableDataRow } from "@containers/organization/organization-invitations/organization-invitations-table-container/organization-invitations-table-container";

type OrganizationInvitationTableCellProps = {
    data: OrganizationInvitationsTableDataRow
};

export const OrganizationInvitationTableCell = (props: OrganizationInvitationTableCellProps) => {
    const {
        data
    } = props;

    const navigate = useNavigate();
    const routerLocation = useLocation();

    const handleOpenComponentDetails = () => {
        const url = injectCustomIdParameter(
            ORGANIZATION_INVITATION_DETAILS_URL,
            data.id,
            ORGANIZATION_INVITATION_ID_PATTERN
        );
        navigateToUtil(url, navigate, routerLocation.pathname);
    }

    const organizationInvitationDropdownItems = useMemo(() => {
        const items: Array<CellDropdownItem> = [];
        const prefix = "organization-invitation-list";

        if (data.permissions.canView) {
            items.push({
                idSuffix: `${prefix}-open`,
                title: resources.tables.organizationInvitations.dropdownItems.open.label,
                text: resources.tables.organizationInvitations.dropdownItems.open.label,
                onClick: handleOpenComponentDetails
            });
        }
        return items;
    }, []);






    return (
        <TableCellWithDropdown
            value={data.email}
            dropdownText={""}
            items={organizationInvitationDropdownItems}
            uniqueId={data.id}
        />
    );
};